angular.module( 'acme.view.application.entities.templates.create', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.entities.templates.create.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var entitiesTemplatesCreate = {
        name: 'application.entities.templates.create',
        url: '/create',
        views: {
          "subview-main@application.entities": {
            controller: 'EntitiesTemplatesCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/entities/templates/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: '   '
        }
      },
      entitiesTemplatesEdit = {
          name: 'application.entities.templates.edit',
          url: '/:id/edit',
          views: {
              "subview-main@application.entities": {
                  controller: 'EntitiesTemplatesCreateController',
                  // Assumes the view is entirely self contained
                  templateUrl: 'views/application/views/entities/templates/create/create.tpl.html'
              }
          },
          data: {
              pageTitle: '   '
          }
      };

    $stateProvider
      .state(entitiesTemplatesCreate)
      .state(entitiesTemplatesEdit);
});
